module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/fails.js
// module id = 19
// module chunks = 0